import React from 'react'

// react router
import { Link } from 'react-router-dom';

// logo
import stLogo from 'assets/images/logo.jpg'

export default function Logo() {
    return (
        <div className="logo">
            <Link to="/home" className="d-inline-block text-decoration-none">
                {/* <p className="logo mb-0">Krave</p> */}
                <img src={stLogo} alt="logo" className="img-fluid" />
            </Link>
        </div>
    )
}
